import { Component, OnInit, HostListener, TemplateRef } from '@angular/core';
import { DescriptionComponent } from '../description.component';
import { TextService } from '../../../services/text.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/services/guard/auth.service';
import { TextModel } from '../../../models/text';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-description-full',
  templateUrl: './description-full.component.html',
  styleUrls: ['./description-full.component.scss']
})
export class DescriptionFullComponent extends DescriptionComponent implements OnInit {
  textModel: TextModel;
  modalRef: BsModalRef;

  scrolling = false;
  container: JQuery<HTMLElement>;
  currentSection = 0;
  sections: any;

  pictures: any;

  isAdmin: boolean;

  public previewUrl: string;
  public isPreview: boolean;

  constructor(
    textService: TextService,
    translate: TranslateService,
    authService: AuthService,
    private modalService: BsModalService,
    private toast: ToastrService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(textService, translate, authService, deviceDetectorService, route);
  }

  ngOnInit() {
    super.ngOnInit();
    this.container = $('.sections');
    this.sections = this.container.children('.section');
    this.pictures = $('.slide-picture');

    document.getElementById('sections').addEventListener('wheel', (event) => {
      if (this.scrolling) {
        return false;
      }
      if (event.deltaY < 0) {
        this.previousSection();
      } else if (event.deltaY > 0) {
        this.nextSection();
      }
    });


    $(this.pictures[1]).css({ opacity: '0' });
    $(this.pictures[2]).css({ opacity: '0' });
    $(this.pictures[0]).css({ transform: `translate3d(${this.getPicturePercentage()}%, 0px, 0px)` });
  }

  getPicturePercentage(): number {
    // since clientWidth is not working, calculate width based on height ratio
    const p = this.pictures[this.currentSection];
    const hRatio = p.clientHeight / p.naturalHeight;
    const pictureWidth = p.naturalWidth * hRatio;

    const containerWidth = this.container.width();
    const ratio = (pictureWidth / containerWidth) - 0.1;
    if (ratio > 0.75) {
      return 10 + (ratio * 20);
    }
    return 10;
  }

  nextSection() {
    if (this.currentSection === this.sections.length - 1) {
      return false;
    }
    this.currentSection++;
    this.goToSection(this.currentSection - 1);
  }

  previousSection() {
    if (this.currentSection === 0) {
      return false;
    }
    this.currentSection--;
    this.goToSection(this.currentSection + 1);
  }

  @HostListener('window:resize', ['$event'])
  updatePicture() {
    $(this.pictures[this.currentSection]).css({ transform: `translate3d(${this.getPicturePercentage()}%, 0px, 0px)` });
  }

  goToSection(previousSection: number) {
    this.scrolling = true;
    setTimeout(() => {
      this.scrolling = false;
    }, 1500);

    const top = $(this.sections[this.currentSection]).position().top + this.container.scrollTop();
    this.container.animate({ scrollTop: top }, 500, $.bez([1, 0, 0.18, 1]));
    this.switchPicture(previousSection);
  }

  switchPicture(from: number) {
    const currentPicture = $(this.pictures[from]);

    const picture = $(this.pictures[this.currentSection]);
    picture.css({ opacity: 1 });

    if (from > this.currentSection) {
      currentPicture.css({ transform: 'translate3d(100%, 0px, 0px)' });
    }
    currentPicture.css({ opacity: 0 });

    if (this.currentSection !== 0) {
      picture.css({ transform: `translate3d(${this.getPicturePercentage()}%, 0px, 0px)` });

      if (this.currentSection === 1) {
        $(this.pictures[2]).css({ opacity: 0 });
      }
    }
  }

  scrollTo(section: number) {
    const diff = this.currentSection - section;
    if (diff === 0) {
      return;
    }
    if (diff < 0) {
      while (this.currentSection < section) {
        this.currentSection++;
        this.goToSection(this.currentSection - 1);
      }
    } else {
      while (this.currentSection > section) {
        this.currentSection--;
        this.goToSection(this.currentSection + 1);
      }
    }
  }

  //#region UPDATE TEXT
  updateText(textModel: TextModel, template: TemplateRef<any>) {
    if (!this.isAdmin) {
      return;
    }
    this.textModel = new TextModel();
    Object.assign(this.textModel, textModel);

    this.modalRef = this.modalService.show(template);
  }

  saveTextModel() {
    this.textService.saveText(this.textModel).subscribe(
      () => {
        this.modalRef.hide();
        this.toast.success('Text saved');
      },
      err => {
        console.error(err);
        this.toast.error(err.message);
      },
      () => super.ngOnInit()
    );
  }
  //#endregion
}
